import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { BaseComponent, UserService, RmaService } from "@mypxplat/xplat/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({
  selector: "myp-rma",
  templateUrl: "rma.component.html",
})
export class RmaComponent extends BaseComponent implements OnInit, OnDestroy {
  public rmaData;
  public loading: boolean = true;

  constructor(userService: UserService, private rmaService: RmaService, private _router: Router) {
    super(userService);
  }
  ngOnInit(): void {
    this.rmaService.returnAuthurizationItems$.pipe(takeUntil(this.destroy$)).subscribe((returnAuth: any) => {
      this.rmaData = returnAuth;
      this.loading = false;
    });
    this.rmaService.getRmas();
  }

  goShopping() {
    window.open("https://shop.presonus.com");
  }

  goToSupport() {
    this._router.navigate(["/support/knowledgebase"]);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
